import { useTranslation } from 'react-i18next'
import { Modal } from 'antd'

import ImageWithFallBack from '@/components/ImageWithFallback'
import DangerouslySetInnerElement from '@/components/SpecialSymbolElement'
import { useDeviceDetect } from '@/hooks'
import ItemNumberExampleImage from '@/assets/img/item-number-example.webp'
import SerialNumberExampleImage from '@/assets/img/serial-number-example.webp'

import styles from './HowToFindItemNumber.module.scss'

const IMAGES = {
  itemNumberInfo: ItemNumberExampleImage,
  serialNumberInfo: SerialNumberExampleImage,
}

interface HowToFindItemNumberProps {
  open?: boolean
  type: 'itemNumberInfo' | 'serialNumberInfo'
  onToggle: () => void
}

const HowToFindItemNumber = ({
  open = false,
  onToggle,
  type = 'itemNumberInfo',
}: HowToFindItemNumberProps) => {
  const { t } = useTranslation()
  const { isMobile } = useDeviceDetect()

  const title = t(`service.selectMachine.${type}.title`)
  const description = t(`service.selectMachine.${type}.description`)
  const image = IMAGES[type]

  if (!open) {
    return <div />
  }

  if (isMobile) {
    return (
      <Modal
        open
        footer={null}
        title={title}
        wrapClassName="info-modal--wrapper"
        onCancel={onToggle}
      >
        <DangerouslySetInnerElement rawHTML={description} />
        <div>
          <ImageWithFallBack src={image} />
        </div>
      </Modal>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.image}>
        <ImageWithFallBack src={image} />
      </div>
      <div className={styles.content}>
        <span className={styles.heading}>{title}</span>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default HowToFindItemNumber
